import Vue from 'vue'
import Vuex from 'vuex'

// import VuexPersistence from 'vuex-persist'
import modules from './modules'

Vue.use(Vuex)


// const vuexLocal = new VuexPersistence({
//     storage: window.localStorage,
// });

const store = new Vuex.Store({
    // plugins: [vuexLocal.plugin],
    modules,
    // Enable strict mode in development to get a warning
    // when mutating state outside of a mutation.
    // https://vuex.vuejs.org/guide/strict.html
    // strict: process.env.NODE_ENV !== 'production',
})

export default store
